import { Stack } from "@mantine/core"
import { SectionHeader, Loader } from "@tfg/ui"

import { IngestionListWrapper } from "~/pages/Admin/Ingestion/ProductImport/IngestionListWrapper"
import { IngestionDocumentValidate } from "~/pages/Admin/Ingestion/ProductImport/components/IngestionDocumentValidate"
import { useProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"
import { ProductImportProvider } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportProvider"
import { useAuth } from "~/store/auth-context"
import { OrganizationType } from "@tfg/types/types/organization.types"

export function ProductImport() {
  const { isLoadingOwners } = useProductImportContext()

  const { user } = useAuth()
  if (
    !user ||
    !user.organization ||
    (user.organization.type !== OrganizationType.BRAND &&
      user.organization.type !== OrganizationType.PLATFORM_ADMIN)
  ) {
    return null
  }

  return (
    <ProductImportProvider>
      <Stack>
        <SectionHeader />
        <IngestionDocumentValidate />
        {isLoadingOwners ? <Loader fullPage /> : <IngestionListWrapper />}
      </Stack>
    </ProductImportProvider>
  )
}
